import Vue from 'vue'
import phaseOperationsSimple from './phaseOperationsSimple.vue'

const PhaseOperationsSimple = Vue.extend(phaseOperationsSimple)

export function templatePhaseOperationsSimplexVue({ module }) {
  const phaseOperations = new PhaseOperationsSimple({
    propsData: {
      module
    }
  }).$mount()
  return phaseOperations.$el
}
